import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Outlet } from "react-router-dom";
import { AppContext } from "../App";

export type filesData = {
  droppable?: boolean;
  text: string;
  data?: {
    fileType: string;
    fileExtension: string;
    fileSize: string;
  };
};

interface Context {
  currentPath: string;
  gettingFiles: boolean;
  moveFile: {
    old_path: string,
    new_path: string,
  };
  project: {
    id: string;
    name: string;
    description: string;
    status: string;
    files_data?: filesData[];
  };
}

const initialContext: Context = {
  currentPath: "",
  gettingFiles: false,
  moveFile: {
    old_path: "",
    new_path: "",
  },
  project: {
    id: "",
    name: "",
    description: "",
    status: "",
    files_data: [],
  },
};
const FileStructureContext = createContext<Context>(initialContext);

const FileStructureContextProvider = (): JSX.Element => {
  const { user } = useContext(AppContext);
  const [state, setStates] = useState<Context>(initialContext);

  const setState = (object: any) => setStates((prevState: any) => ({ ...prevState, ...object }));

  const getProjectDetails = async (uuid: string) => {
    if (!user.permissions.includes("view_project_details")) return;

    try {
      const {
        data: { data },
      } = await axios.get("/smart-contract/get-project-details", {
        params: { uuid },
      });

      setState({ project: data });
    } catch (error) {
      toast.error("Error fetching project details");

      console.log({ error });
    }
  };

  const getFiles = async () => {
    if (!user.permissions.includes("view_files")) return;

    setState({ gettingFiles: true });
    try {
      const {
        data: { data },
      } = await axios.get("/deploy/get-files", {
        params: {
          project_uuid: state.project.id,
          path: state.currentPath,
        },
      });

      setState({ project: { ...state.project, files_data: data } });
    } catch (error) {
      console.log({ error });

      toast.error("Error fetching files");
    }

    setState({ gettingFiles: false });
  };

  const handleDeleteTreeItem = async (item: filesData, path?: string) => {
    if (!user.permissions.includes("delete_file")) return toast.error("You don't have permission to delete files");

    try {
      const { data } = await axios.post("/deploy/delete-file", {
        project_uuid: state.project.id,
        path,
      });

      console.log(data);

      setState({
        project: {
          ...state.project,
          files_data: state.project.files_data?.filter((file: filesData) => file.text !== item.text),
        }
      });
      toast.success(`${item.droppable ? "Folder" : "File" } deleted successfully`);
    } catch (error: any) {
      console.log({ error });

      toast.error(
        error.response.data.message || "Error deleting file. Please check your console for more details"
      )
    }
  }
  
  const handleEditFileName = async () => {
    console.log("handleEditFileName");
  }

  useEffect(() => {
    if (!state.currentPath) return;

    getFiles();
  }, [state.currentPath]);

  return (
    <Outlet context={{ ...state, handleDeleteTreeItem, handleEditFileName, getProjectDetails, setState }} />
  );
};

export { FileStructureContext, FileStructureContextProvider };
